import React from 'react';
import './HeavyLink.css';


const HeavyLink = (props) => {

  return (
      <a  className={`p-button p-component p-button-outlined p-button-secondary HeavyLink ${props.btClass || ''}`} href={props.href} target='_blank' rel="noreferrer">{props.content}</a>
    );
}


export default HeavyLink;
